export interface PageViewsInterface {
  webViews?: number;
  mobileViews?: number;
}
